export const PERMITTED_FILE_TYPES = ['.xlsx', '.xls', '.csv'];

export const getFileKey = (employeeListFile: File, org: Org) => {
  const fileExtension = employeeListFile.name.split('.').pop();
  return `org/${org.org_key}/employee-lists/${
    org.org_key
  }_employee_list_${new Date().getTime()}.${fileExtension}`;
};

export const isSupportedFileExtension = (employeeListFile: File) => {
  const fileExtension = employeeListFile.name.split('.').pop();
  return fileExtension && PERMITTED_FILE_TYPES.includes(`.${fileExtension}`);
};
